module.exports = __webpack_public_path__ + "img/banner-affordable-and-clean-energy.311e429f.png";